import React from 'react'

export default function Principles() {
  return (
    <section className='mt-5 mb-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-12 principles'>


                <div className='mb-3 '>
                        <h4 className='font-italic d-inline p-1 bg-warning'>Guiding Principles</h4><br></br>
                    </div>



                    <div>
                        <p>The National Invasive Species Strategy and Action Plan (NISSAP) promotes the following principles in the management of invasive alien species.
                        </p><br></br>
                        

                        <div>
                            <p>   a) Risk Management</p>
                            <ul>    
                                <li>Management of invasive species that pose the greatest risk.</li>
                                <li> Management methods that reduce the risk to biodiversity, cultural and productive assets and to people.</li>
                            </ul>
                        </div>

                        <div>
                            <p>  b) Asset Based</p>
                            <ul>    
                                <li>Protecting the highest value assets at the greatest risk.</li>
                            </ul>
                        </div>
                       

                        <div>
                            <p>  c) Biosecurity Approach</p>
                            <ul>    
                                <li>Management of invasive species at all stages of invasion.</li>
                                <li>Economic returns for managing invasive species are much higher when infestations are new or small.</li>
                            </ul>
                        </div>
                        


                        
                        <div>
                            <p>  d) Landscape Scale</p>
                            <ul>    
                                <li>Landscape scale means considering invasive species from the impact on an individual plant or animal, a property, or the country level.
Invasive species can disperse long distances and therefore need to be managed collectively at a landscape scale to achieve long term benefits.
</li>
                            </ul>
                        </div>


                        <div>
                            <p>  e) Collaborative/Cross-Tenure</p>
                            <ul>    
                                <li> Management of invasive species is only achieved at a landscape scale when we work together across different land tenures.</li>
                            </ul>
                        </div>


                        <div>
                            <p>  f) Strategic</p>
                            <ul>    
                                <li>  Decisions are based on the best available evidence.</li>
                                <li>Planning manages risks, is asset based and follows the biosecurity approach.</li>
                                <li>Planning is targeted, coordinated and integrated across different programs and different stakeholders.</li>
                            </ul>
                        </div>


                        <div>
                            <p>  g) MERI Approach</p>
                            <ul>    
                                <li>  Monitoring –collecting the data</li>
                                <li>Evaluating –interpreting the data</li>
                                <li>Reporting –presenting the monitoring and evaluation</li>
                                <li>Improving-changing processes based on monitoring and evaluation.</li>
                            </ul>
                        </div>


                        <div>
                            <p>  h) Ethical</p>
                            <ul>    
                                <li> Invasive species are living creatures and therefore control methods should minimize pain (humane control methods).</li>
                                <li>Prevention and methods that keep species at lower numbers reduces the need for culling</li>

                            </ul>
                        </div>














                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}